import React from "react";
import {Avatar, Typography} from '@material-ui/core';
import './AdminStepCard.scss';

export const AdminStepCard = ({avatar, title, className, children}) => {

    return (
        <div className={`${className} adminStepCard`}>
            <div className="card-header">
                <Avatar className="--avatar">{avatar}</Avatar>
                <Typography variant="h6" className="--typo" >{title}</Typography>
            </div>
            <div className="card-body">
                {children}
            </div>
        </div>
    )
}

export default AdminStepCard;